<template>
  <div class="relative lg:grid lg:cols-12 lg:mb-8 lg:items-start">
    <!-- Desktop Horizontal Scroll Gallery Skeleton - Full Width (breaks out) -->
    <div class="hidden lg:w-screen lg:flex lg:gap-2 lg:overflow-hidden">
      <div
        v-for="i in 6"
        :key="i"
        class="shrink-0 rounded-lg skeleton"
        :style="{
          'aspect-ratio': width / height,
          'height': `max(44rem, calc(100dvh - ${pxToRem(header.height.full + 24)}))`,
        }"
      />
    </div>
    <!-- Mobile/Tablet Gallery Skeleton -->
    <div
      class="skeleton lg:hidden"
      :style="{ 'aspect-ratio': width / height }"
    />
    <!-- Product Info Skeleton - Scrollable, positioned over gallery -->
    <div
      class="px-4 py-6 lg:absolute lg:right-0 lg:top-0 lg:col-span-5 lg:col-start-8 lg:row-start-3 lg:m-8 lg:h-screen lg:max-w-141 lg:w-full lg:justify-self-end lg:rounded-lg lg:bg-brand-3 lg:bg-op-90 lg:p-6 lg:backdrop-blur-md"
    >
      <!-- product name + short description + rating -->
      <div class="space-y-4">
        <div class="mt-2 h-7 w-full skeleton" />
        <div class="h-3 w-50 skeleton" />
        <div class="h-3 w-20 skeleton" />
      </div>

      <!-- Price -->
      <div class="mt-6 b-y b-grey-80 py-6 space-y-3">
        <div class="h-7 w-30 skeleton" />
      </div>

      <!-- Color swatches -->
      <div class="my-4 space-y-4">
        <div class="h-4 w-40 skeleton" />
        <div class="flex gap-2 wrap">
          <div
            v-for="i in 7"
            :key="i"
            class="h-6 w-10 skeleton"
          />
        </div>
      </div>

      <!-- Size selection -->
      <div class="my-4 space-y-3">
        <div class="h-4 w-20 skeleton" />
        <div class="flex gap-2 wrap">
          <div
            v-for="i in 6"
            :key="i"
            class="h-10 skeleton"
            style="width: 3.5rem"
          />
        </div>
        <!-- Model measurements block -->
        <div class="mt-3 flex items-center gap-2 rounded-lg bg-op-60 p-3">
          <div class="h-6 w-6 shrink skeleton" />
          <div class="h-3 w-60 skeleton" />
        </div>
        <div class="h-0.5 w-full bg-grey-80" />
        <div class="mt-1 h-3 w-20 skeleton" />
      </div>

      <!-- Fit -->
      <div class="my-4 space-y-3">
        <div class="h-4 w-30 skeleton" />
        <div class="flex gap-2">
          <div class="h-10 w-24 skeleton" />
          <div class="h-10 w-16 skeleton" />
        </div>
      </div>

      <!-- Style -->
      <div class="my-4 space-y-3">
        <div class="h-4 w-20 skeleton" />
        <div class="flex gap-2">
          <div class="h-10 w-20 skeleton" />
          <div class="h-10 w-28 skeleton" />
          <div class="h-10 w-20 skeleton" />
        </div>
      </div>

      <!-- Klarna text -->
      <div class="h-3 w-80 skeleton" />

      <!-- CTA buttons -->
      <div class="mt-4 flex gap-2">
        <div class="h-12 grow skeleton" />
        <div class="h-12 w-12 shrink skeleton" />
      </div>

      <!-- Divider + In-Store Pickup -->
      <div class="mt-4 b-t b-grey-80" />
      <div class="mt-4 space-y-1">
        <div class="h-5 w-36 skeleton" />
        <div class="h-3 w-20 skeleton" />
        <div class="h-3 w-70 skeleton" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const { width, height } = useAppConfig().pages.pdp.gallery.presets.src

const header = useHeaderStore()
</script>
